import { useMemo } from "react";
import "./PromptWizardTabs.scss";

const PromptWizardTabs = ({
  tabs,
  activeTab,
  setActiveTab,
  tabWidth = 160,
  padding = 2,
}) => {
  const containerWidth = tabs.length * tabWidth;
  const indicatorWidth = containerWidth / tabs.length - 10; // 10 is to make indicator not touch the edges

  const leftDistance = useMemo(() => {
    const isLeftEdge = activeTab === 0;
    const isRightEdge = activeTab === tabs.length - 1;

    if (isLeftEdge) {
      return padding;
    }

    if (isRightEdge) {
      return containerWidth - indicatorWidth - padding;
    }

    return activeTab * tabWidth;
  }, [
    activeTab,
    containerWidth,
    indicatorWidth,
    padding,
    tabWidth,
    tabs.length,
  ]);

  return (
    <div className="prompt-wizard-home-tabs">
      {/* Active Indicator */}
      <div
        className="active-indicator"
        style={{ width: indicatorWidth, left: leftDistance }}
      />

      {tabs.map((tab, index) => (
        <div
          key={index}
          className={`tab ${activeTab === index ? "active" : ""}`}
          onClick={() => setActiveTab(index)}
          style={{ width: tabWidth }}
        >
          {tab}
        </div>
      ))}
    </div>
  );
};
export default PromptWizardTabs;
